class PlayNext {

    /** PlayNext.js
     * Autoplays next video with a 15s countdown.
     */
    constructor(options) {
        console.log('Simplestream::PlayNext::constructor()');

        // Validate options
        if(!options.parent) {
            console.error('Simplestream::PlayNext: Missing parent');
            return;
        } else if(!options.container) {
            console.error('Simplestream::PlayNext: Missing container');
            return;
        } else if(!options.videoElement) {
            console.error('Simplestream::PlayNext: Missing videoElement');
            return;
        } else if(!options.playerApiResponse) {
            console.error('Simplestream::PlayNext: Missing playerApiResponse');
            return;
        } else if(!options.attributes) {
            console.error('Simplestream::PlayNext: Missing attributes');
            return;
        }

        // Set options
        this.parent = options.parent;
        this.container = options.container;
        this.videoElement = options.videoElement;
        this.playerApiResponse = options.playerApiResponse;
        this.attributes = options.attributes;
        this.countdownTimerInSeconds = 30;

        this.callPlayNextApi();
    }

    /**
     * Call Play Next API to get the next video.
     */
    callPlayNextApi() {
        console.log('Simplestream::PlayNext::callPlayNextApi()');

        var url = this.playerApiResponse.api_hostname + '/play-next/v1/' + this.playerApiResponse.company_uuid + '/' + this.attributes.uvid;
        url += '?key=' + this.attributes.key;
        url += '&lang=en';
        url += '&cc=IE';
        url += '&platform=web';
        url += '&content_type=' + this.attributes.type;
        url += '&section_id=unknown';
        url += '&endPoint=unknown';

        fetch(url, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-api-key': this.attributes.key,
            },
        }).then((response) => {
            return response.json();
        }).then((json) => {
            this.playNextApiResponse = json;
            console.log('Play Next API Response:\n' + JSON.stringify(this.playNextApiResponse, undefined, 2));
            this.showPlayNextAt = this.timeStringToSeconds(this.playNextApiResponse.playnext_timecode_offset);
            this.init();
        }).catch((error) => {
            console.log('Could not connect to Play Next API', error);
        });
    }

    /**
     * Initialise the playnext container and events.
     */
    init() {
        console.log('Simplestream::PlayNext::init() - ' + this.showPlayNextAt);

        const htmlContent = `
        <div id="playNext" class="playnext-container">
            <div class="playnext-image">
                <img src="${this.playNextApiResponse.series_image}" />
                <div class="playnext-countdown">
                    <div id="countdown"></div>
                </div>
            </div>
            <div class="playnext-text">
                <p class="playnext-text-title">${this.playNextApiResponse.series_title}</p>
                <p class="playnext-text-subtitle">Season ${this.playNextApiResponse.season_number}, Episode ${this.playNextApiResponse.episode_number}</p>
            </div>
        </div>`;
        this.container.insertAdjacentHTML('beforeend', htmlContent);

        this.playNextContainer = document.getElementById('playNext');
        this.playNextImage = document.getElementById('playNextImage');
        this.playNextCountdown = document.getElementById('playNextCountdown');
        this.playNextTitle = document.getElementById('pauseAdSlot');

        this.playNextContainer.addEventListener('click', () => {
            this.upNext();
        });

        let handleTimeUpdate = function() {
            var currentTime = Math.floor(this.videoElement.currentTime);
            var duration = Math.floor(this.videoElement.duration);
            if(duration - currentTime < this.showPlayNextAt) {
                this.videoElement.removeEventListener('timeupdate', handleTimeUpdate);
                this.showPlayNext();
                this.countdownTimer();
            }
        }.bind(this);

        this.videoElement.addEventListener('timeupdate', handleTimeUpdate);
    }

    /**
     * Hide/Show the pause ad container by adjusting the z-index.
     */
    showPlayNext() {
        console.log('Simplestream::PlayNext::showPlayNext()');
        this.playNextContainer.style.display = 'flex';
    }

    /**
     * Convert 00:00::00 time string to seconds.
     */
    timeStringToSeconds(timeString) {
        const timeParts = timeString.split(':');
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const seconds = parseInt(timeParts[2], 10);
        return (hours * 3600) + (minutes * 60) + seconds;
    }

    /**
     * Render the 30s countdown timer.
     */
    countdownTimer() {

        this.timer = {};
        this.timer.fullDashArray = 283;
        this.timer.colors = {
            info: {
                color: "white"
            },
            warning: {
                color: "white",
                threshold: 10
            },
            alert: {
                color: "white",
                threshold: 5
            }
        };
        this.timer.timeLimit = this.showPlayNextAt;
        this.timer.timePassed = 0;
        this.timer.timeLeft = this.timer.timeLimit;
        this.timer.timerInterval = null;

        document.getElementById("countdown").innerHTML = `
            <div class="base-timer">
                <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <g class="base-timer__circle">
                        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
                        <path
                            id="base-timer-path-remaining"
                            stroke-dasharray="283"
                            class="base-timer__path-remaining ${this.timer.colors.info.color}"
                            d="
                            M 50, 50
                            m -45, 0
                            a 45,45 0 1,0 90,0
                            a 45,45 0 1,0 -90,0
                            "
                        ></path>
                    </g>
                </svg>
                <span id="base-timer-label" class="base-timer__label">${this.formatTime(this.timer.timeLeft)}</span>
            </div>
        `;

        this.startTimer();

    }

    startTimer() {
        this.timer.timerInterval = setInterval(() => {
            this.timer.timePassed = this.timer.timePassed += 1;
            this.timer.timeLeft = this.timer.timeLimit - this.timer.timePassed;
            document.getElementById("base-timer-label").innerHTML = this.formatTime(this.timer.timeLeft);
            this.setCircleDasharray();
            this.setRemainingPathColor(this.timer.timeLeft);
            if (this.timer.timeLeft === 0) {
                this.upNext();
            }
        }, 1000);
    }

    upNext() {
        clearInterval(this.timer.timerInterval);
        document.getElementById("countdown").innerHTML = '';
        this.parent.changeUvid(this.playNextApiResponse.playnext_uvid);
    }

    formatTime(time) {
        const minutes = Math.floor(time / 60);
        let seconds = time % 60;
        if (seconds < 10) {
            seconds = `0${seconds}`;
        }
        return `${minutes}:${seconds}`;
    }

    setRemainingPathColor(timeLeft) {
        const { alert, warning, info } = this.timer.colors;
        if (timeLeft <= alert.threshold) {
            document.getElementById("base-timer-path-remaining").classList.remove(warning.color);
            document.getElementById("base-timer-path-remaining").classList.add(alert.color);
        } else if (timeLeft <= warning.threshold) {
            document.getElementById("base-timer-path-remaining").classList.remove(info.color);
            document.getElementById("base-timer-path-remaining").classList.add(warning.color);
        }
    }

    setCircleDasharray() {
        const circleDasharray = `${(this.calculateTimeFraction() * this.timer.fullDashArray).toFixed(0)} 283`;
        document.getElementById("base-timer-path-remaining").setAttribute("stroke-dasharray", circleDasharray);
    }

    calculateTimeFraction() {
        const rawTimeFraction = this.timer.timeLeft / this.timer.timeLimit;
        return rawTimeFraction - (1 / this.timer.timeLimit) * (1 - rawTimeFraction);
    }
}

export default PlayNext;